import React from "react"
import PropTypes from "prop-types"

class TransactionErrors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      report: null,
      isLoading: false,
      errorMessage: null,
      web_aws_access_key_id: props.web_aws_access_key_id,
      web_aws_secret_access_key: props.web_aws_secret_access_key,
      aws_env_name: props.aws_env_name,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    console.log("value: "+value);
    this.fetchTransactionErrors();
  }

  padTime(s) {
    var s = Math.floor(s);
    if (s >= 10) {
      return ""+s;
    }
    return "0"+s;
  }

  formatTime(str) {
    if (str == null) {
      return "";
    }
    var date = new Date(str);
    var day = date.getDate();
    var month = date.getMonth()+1;
    return ""+month+"/"+day+" "+this.padTime(date.getHours())+":"+this.padTime(date.getMinutes())+":"+this.padTime(date.getSeconds());
  }

  render () {
    var header = "No transaction errors";
    if (this.state.errorMessage) {
      header = this.state.errorMessage;
    }

    if (this.state.report == null) {
      const message = this.state.errorMessage || "Report not available"
      return (
        <React.Fragment>
        <div id="transaction_errors" className={this.state.isLoading ? "loading" : "done-loading"}>
          <p>{message}.</p>
        </div>
        </React.Fragment>

      )
    }

    console.log("report: "+JSON.stringify(this.state.report));
    console.log("Rendering with report record count: "+this.state.report.records.length);

    var main_table = "";
    if (this.state.report.records.length > 0) {
      header = ""+this.state.report.records.length+" transaction errors";

      var html_rows = [];
      for (var row = 0; row < this.state.report.records.length; row++) {
        var record = this.state.report.records[row];
        var html_row = (
            <tr key={row}>
            <td>{this.formatTime(record.entered_at)}</td>
            <td>{this.formatTime(record.exited_at)}</td>
            <td>{record.garage_name}</td>
            <td>{record.reader_name}</td>
            <td>{record.firstname} {record.lastname}</td>
            <td>{record.member_id}</td>
            <td>{record.plate}</td>
            <td>{record.credential}</td>
            <td>{record.transaction_id}</td>
            <td>{record.error}</td>
            </tr>
        );
        html_rows.push(html_row)
      }
      main_table = (
        <table className="main_table">
        <tbody>
            <tr>
            <th>Entered At</th>
            <th>Exited At</th>
            <th>Garage</th>
            <th>Reader</th>
            <th>Name</th>
            <th>Member Id</th>
            <th>Plate</th>
            <th>Credential</th>
            <th>Transaction Id</th>
            <th>Error</th>
            </tr>
        {html_rows}
        </tbody>
        </table>
      );
    }
    return (
        <React.Fragment>
        <div id="suspicious_activity" className={this.state.isLoading ? "loading" : "done-loading"}>
        <h1>Transaction Error Report</h1>
        <div id="header">
        <p>{header}</p>
        </div>
        {main_table}
        </div>
        </React.Fragment>
      )

  }

  async fetchTransactionErrors() {
    console.log("Fetching transaction errors");
    var url = this.props.baseUrl+"/api/v2/transits_reports/transaction_errors"
    this.setState({isLoading: true, errorMessage: null});
    try {
      const response = await fetch(url);
			if (response.status == 200) {
        console.log("good status back");
				const json = await response.json();
				if (json.errors && typeof json.errors === 'object' && json.errors.constructor === Array && json.errors.length > 0) {
					errorMessage = json.errors.join("; ");
					this.setState({report: null, isLoading: false, errorMessage: errorMessage});
					return Promise.reject(new Error(errorMessage))
				}
				else {
          console.log("setting report");
					this.setState({report: json, isLoading: false, errorMessage: null});
					return;
				}
			}
			else {
				var errorMessage = response.statusText;
				if (response.status == 404) {
					errorMessage = "Report not available";
				}
				this.setState({report: null, isLoading: false, errorMessage: errorMessage});
			}
    }
    catch (error) {
      console.log(error);
			this.setState({isLoading: false});
			const errorString = ""+error;
			this.setState({report: null, isLoading: false, errorMessage: ''+error});
    }
  }

  async componentDidMount() {
    await this.fetchTransactionErrors();
  }

}



TransactionErrors.propTypes = {
  greeting: PropTypes.string
};

export default TransactionErrors;